import PropTypes from 'prop-types';
import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import R from 'ramda';
import classNames from 'classnames';

import styles from './container.css';

const Container = ({
    theme = 'transparent',
    containAt = ['small', 'medium', 'large'],
    size,
    alignItems = 'center',
    directions = ['horizontal', 'vertical'],
    className,
    ...props
}) => {
    const sizeClasses = classNames(
        className,
        styles[alignItems],
        styles.size,
        ...R.map((direction) => R.prop(`${direction}Container`, styles), directions),
        {
            [styles.small]: R.contains('small', containAt),
            [styles.medium]: R.contains('medium', containAt),
            [styles.large]: R.contains('large', containAt),
            [styles.containerBig]: R.equals(size, 'big'),
            [styles.containerBigTop]: R.equals(size, 'bigTop'),
            [styles.containerBigBottom]: R.equals(size, 'bigBottom')
        }
    );

    const { div } = hh(h);

    return (
        div({className: classNames(styles.container, R.prop(theme, styles))}, [
            div({className: sizeClasses, ...props})])
    );
};


Container.propTypes = {
    theme: PropTypes.string,
    containAt: PropTypes.array,
    size: PropTypes.string,
    directions: PropTypes.array,
    className: PropTypes.string
};

export default Container;



/** WEBPACK FOOTER **
 ** ./src/Container/index.js
 **/